import styles from './ProjectTrafficLightStatusSwitcher.module.scss';

import clsx from 'clsx';

import { TrafficLightStatus } from '@work4all/models/lib/Enums/TrafficLightStatus.enum';

import { EntityPickerPopover } from '../entity-picker/components';
import { ProjectTrafficLightStatusPicker } from '../entity-picker/project-traffic-light-status-picker/ProjectTrafficLightStatusPicker';
import { TrafficLightStatusIndicator } from '../traffic-light-status-indicator/TrafficLightStatusIndicator';

type Props = {
  value: TrafficLightStatus;
  onChange: (value: TrafficLightStatus) => void;
  disabled?: boolean;
  classes?: {
    button?: string;
  };
};

export const ProjectTrafficLightStatusSwitcher = ({
  value,
  onChange,
  disabled,
  classes,
}: Props) => {
  return (
    <EntityPickerPopover
      picker={
        <ProjectTrafficLightStatusPicker
          multiple={false}
          value={{ id: value, name: value }}
          onChange={(value) => {
            onChange(value.id as TrafficLightStatus);
          }}
        />
      }
      disabled={disabled}
    >
      <button type="button" className={clsx(styles.button, classes?.button)}>
        <TrafficLightStatusIndicator value={value} />
      </button>
    </EntityPickerPopover>
  );
};
